module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/057-burundi-9f28cd0ab5d44cecc4b0638959f219d6.svg";